import replace from "lodash/replace";
const escapeId = (id) => replace(id, /(:|\.|#|\s)/g, "\\$&");
export default escapeId;
